(() => {
    console.log('🎁 Free Gift script iniciado');

    const GIFT_PRODUCT_ID = 8878042087561;
    const MINIMUM_SUBTOTAL = 250000;

    let processing = false;
    const productCache = new Map();

    // =========================================================
    // OBTENER VARIANTE DEL REGALO
    // =========================================================
    async function getGiftVariantId() {
        let page = 1;

        while (page <= 20) {
            const response = await fetch(
                `/products.json?limit=250&page=${page}&_=${Date.now()}`,
                {
                    headers: {
                        'Cache-Control': 'no-cache'
                    }
                }
            );

            if (!response.ok) {
                throw new Error(
                    `No se pudo obtener productos: ${response.status}`
                );
            }

            const data = await response.json();

            const product = data.products.find(
                product =>
                    Number(product.id) === GIFT_PRODUCT_ID
            );

            if (product) {
                if (
                    !product.variants ||
                    product.variants.length === 0
                ) {
                    throw new Error(
                        `El producto ${GIFT_PRODUCT_ID} no tiene variantes`
                    );
                }

                return Number(product.variants[0].id);
            }

            if (
                !data.products ||
                data.products.length < 250
            ) {
                break;
            }

            page++;
        }

        throw new Error(
            `No se encontró el producto regalo ${GIFT_PRODUCT_ID}`
        );
    }

    // =========================================================
    // OBTENER CARRITO
    // =========================================================
    async function getCart() {
        const response = await fetch(
            `/cart.js?_=${Date.now()}`,
            {
                headers: {
                    'Cache-Control': 'no-cache'
                }
            }
        );

        if (!response.ok) {
            throw new Error(
                `Failed to get cart: ${response.status}`
            );
        }

        return await response.json();
    }

    // =========================================================
    // OBTENER PRODUCTO REAL DE SHOPIFY
    // =========================================================
    async function getProduct(handle) {

        if (!handle) {
            return null;
        }

        if (productCache.has(handle)) {
            return productCache.get(handle);
        }

        try {

            const response = await fetch(
                `/products/${handle}.js?_=${Date.now()}`,
                {
                    headers: {
                        'Cache-Control': 'no-cache'
                    }
                }
            );

            if (!response.ok) {
                console.warn(
                    `No se pudo obtener producto ${handle}`
                );

                return null;
            }

            const product = await response.json();

            productCache.set(
                handle,
                product
            );

            return product;

        } catch (error) {

            console.error(
                `Error obteniendo producto ${handle}:`,
                error
            );

            return null;
        }
    }

    // =========================================================
    // DETERMINAR SI LA VARIANTE ESTÁ EN OFERTA
    // =========================================================
    async function isSaleProduct(item) {

        const product =
            await getProduct(item.handle);

        if (!product) {
            return false;
        }

        const variant =
            product.variants.find(
                variant =>
                    Number(variant.id) ===
                    Number(item.variant_id)
            );

        if (!variant) {
            return false;
        }

        const price =
            Number(variant.price);

        const compareAtPrice =
            Number(variant.compare_at_price);

        const isSale =
            compareAtPrice > 0 &&
            compareAtPrice > price;

        if (isSale) {

            console.log(
                '🚫 PRODUCTO EN OFERTA EXCLUIDO:',
                item.product_title,
                {
                    precio: price / 100,
                    precioOriginal: compareAtPrice / 100
                }
            );
        }

        return isSale;
    }

    // =========================================================
    // DETERMINAR SI TIENE DESCUENTO APLICADO
    // =========================================================
    function hasDiscount(item) {

        // Shopify Discount Allocations
        if (
            Array.isArray(item.discount_allocations) &&
            item.discount_allocations.length > 0
        ) {
            return true;
        }

        // Descuentos del carrito
        if (
            Array.isArray(item.discounts) &&
            item.discounts.length > 0
        ) {
            return true;
        }

        // Diferencia entre precio original y final
        if (
            typeof item.original_line_price === 'number' &&
            typeof item.final_line_price === 'number' &&
            item.final_line_price <
            item.original_line_price
        ) {
            return true;
        }

        return false;
    }

    // =========================================================
    // CALCULAR SUBTOTAL ELEGIBLE
    // =========================================================
    async function calculateEligibleSubtotal(cart) {

        let subtotal = 0;

        for (const item of cart.items) {

            // ---------------------------------------------
            // Nunca contar el regalo
            // ---------------------------------------------
            if (
                Number(item.product_id) ===
                GIFT_PRODUCT_ID
            ) {
                continue;
            }

            // ---------------------------------------------
            // DESCUENTO APLICADO
            // ---------------------------------------------
            if (hasDiscount(item)) {

                console.log(
                    '🚫 Producto excluido por descuento:',
                    item.product_title
                );

                continue;
            }

            // ---------------------------------------------
            // PRODUCTO EN OFERTA
            // ---------------------------------------------
            const sale =
                await isSaleProduct(item);

            if (sale) {
                continue;
            }

            // ---------------------------------------------
            // PRODUCTO ELEGIBLE
            // ---------------------------------------------
            const price =
                Number(item.price) *
                Number(item.quantity);

            subtotal += price;

            console.log(
                '✅ Producto elegible:',
                item.product_title,
                `$${(price / 100).toLocaleString('es-CO')}`
            );
        }

        return subtotal / 100;
    }

    // =========================================================
    // AGREGAR REGALO
    // =========================================================
    async function addGift(variantId) {

        const response = await fetch(
            '/cart/add.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 1
                })
            }
        );

        if (!response.ok) {
            throw new Error(
                `Failed to add gift: ${response.status}`
            );
        }

        console.log('🎁 Regalo agregado');
    }

    // =========================================================
    // ELIMINAR REGALO
    // =========================================================
    async function removeGift(lineItemKey) {

        const response = await fetch(
            '/cart/change.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: lineItemKey,
                    quantity: 0
                })
            }
        );

        if (!response.ok) {
            throw new Error(
                `Failed to remove gift: ${response.status}`
            );
        }

        console.log('🎁 Regalo eliminado');
    }

    // =========================================================
    // MANTENER SOLO 1 REGALO
    // =========================================================
    async function changeGiftQuantity(
        lineItemKey,
        quantity
    ) {

        const response = await fetch(
            '/cart/change.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: lineItemKey,
                    quantity: quantity
                })
            }
        );

        if (!response.ok) {
            throw new Error(
                `Failed to change gift quantity: ${response.status}`
            );
        }
    }

    // =========================================================
    // REFRESCAR CARRITO
    // =========================================================
    async function refreshCart() {

        try {

            const cart =
                await getCart();

            const eventDetails = {
                bubbles: true,
                detail: {
                    resource: cart,
                    cart: cart,
                    item_count: cart.item_count
                }
            };

            [
                'cart:refresh',
                'cart:updated',
                'ajaxProduct:added',
                'shopify:cart:change',
                'cart:update',
                'cart:reload',
                'cart:count:update'
            ].forEach(eventName => {

                document.dispatchEvent(
                    new CustomEvent(
                        eventName,
                        eventDetails
                    )
                );
            });

        } catch (error) {

            console.error(
                'Error refrescando carrito:',
                error
            );
        }

        if (
            window.location.pathname ===
            '/cart'
        ) {

            setTimeout(() => {
                window.location.reload();
            }, 300);
        }
    }

    // =========================================================
    // VALIDAR REGALO
    // =========================================================
    async function validateGift() {

        if (processing) {
            return;
        }

        processing = true;

        try {

            const giftVariantId =
                await getGiftVariantId();

            const cart =
                await getCart();

            // ---------------------------------------------
            // BUSCAR REGALO
            // ---------------------------------------------
            const giftItem =
                cart.items.find(
                    item =>
                        Number(item.product_id) ===
                        GIFT_PRODUCT_ID
                );

            // ---------------------------------------------
            // SUBTOTAL REALMENTE ELEGIBLE
            // ---------------------------------------------
            const eligibleSubtotal =
                await calculateEligibleSubtotal(
                    cart
                );

            console.log(
                '💰 SUBTOTAL ELEGIBLE:',
                `$${eligibleSubtotal.toLocaleString('es-CO')}`
            );

            // ---------------------------------------------
            // ¿CALIFICA?
            // ---------------------------------------------
            const qualifies =
                eligibleSubtotal >=
                MINIMUM_SUBTOTAL;

            console.log(
                qualifies
                    ? '🎁 ✅ CALIFICA PARA REGALO'
                    : '🎁 ❌ NO CALIFICA PARA REGALO'
            );

            // ---------------------------------------------
            // AGREGAR
            // ---------------------------------------------
            if (
                qualifies &&
                !giftItem
            ) {

                await addGift(
                    giftVariantId
                );

                await refreshCart();

                processing = false;
                return;
            }

            // ---------------------------------------------
            // ELIMINAR
            // ---------------------------------------------
            if (
                !qualifies &&
                giftItem
            ) {

                await removeGift(
                    giftItem.key
                );

                await refreshCart();

                processing = false;
                return;
            }

            // ---------------------------------------------
            // SOLO 1 REGALO
            // ---------------------------------------------
            if (
                giftItem &&
                giftItem.quantity > 1
            ) {

                await changeGiftQuantity(
                    giftItem.key,
                    1
                );

                await refreshCart();

                processing = false;
                return;
            }

        } catch (error) {

            console.error(
                '❌ Free Gift Error:',
                error
            );
        }

        processing = false;
    }

    // =========================================================
    // INTERCEPTAR FETCH
    // =========================================================
    const originalFetch =
        window.fetch;

    window.fetch = async function (...args) {

        const response =
            await originalFetch.apply(
                this,
                args
            );

        if (processing) {
            return response;
        }

        const url =
            typeof args[0] === 'string'
                ? args[0]
                : args[0]?.url;

        if (
            url &&
            (
                url.includes('/cart/add') ||
                url.includes('/cart/change') ||
                url.includes('/cart/update') ||
                url.includes('/cart/clear')
            )
        ) {

            setTimeout(
                validateGift,
                800
            );
        }

        return response;
    };

    // =========================================================
    // EVENTOS
    // =========================================================
    document.addEventListener(
        'DOMContentLoaded',
        () => {

            validateGift();

            document.body.addEventListener(
                'click',
                e => {

                    const target =
                        e.target;

                    const isCartAction =
                        target.closest(
                            '[name="add"]'
                        ) ||
                        target.closest(
                            '.add-to-cart'
                        ) ||
                        target.closest(
                            '[id*="AddToCart"]'
                        ) ||
                        target.closest(
                            '.cart-btn'
                        ) ||
                        target.closest(
                            '.js-qty__adjust'
                        ) ||
                        target.closest(
                            '.cart__remove'
                        );

                    if (isCartAction) {

                        setTimeout(
                            validateGift,
                            1200
                        );
                    }
                }
            );
        }
    );

})();